/**
 * This utility helps when trying to size elements based off the browser's
 * inner height. 100vh is not always identical to window.innerHeight. e.g.
 * iOS Safari
 */
const updateInnerHeight = () =>
  document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);

const updateOnLoadInnerHeight = () =>
  document.documentElement.style.setProperty(
    "--load-vh",
    `${window.innerHeight}px`
  );

window.addEventListener("resize", updateInnerHeight);
updateInnerHeight();

if (window.DeviceOrientationEvent) {
  window.addEventListener(
    "deviceorientation",
    () => {
      updateOnLoadInnerHeight();
    },
    true
  );
}
updateOnLoadInnerHeight();
